import React from "react";
import { ResultComparison } from "@learningblocks/storybook-components";
import { Image } from "@learningblocks/shared-components";
import { useIntl } from "react-intl";
import "./style.scss";

export const ResultsComparisonImages = (props) => {
  const intl = useIntl();
  return (
    <ResultComparison
      predictedState={{
        type: "component",
        label: props.predictionData.label,
        component: (
          <Image
            width="100%"
            src={props.predictionData.image.src.replace(
              "{{locale}}",
              intl.locale
            )}
            alt={
              props.predictionData.image.altText &&
              intl.formatMessage({
                id: props.predictionData.image.altText,
                defaultMessage: props.predictionData.image.altText,
                description: "",
              })
            }
          />
        ),
      }}
      actualState={{
        type: "component",
        label: props.actualData.label,
        component: (
          <Image
            width="100%"
            src={props.actualData.image.src.replace("{{locale}}", intl.locale)}
            alt={
              props.actualData.image.altText &&
              intl.formatMessage({
                id: props.actualData.image.altText,
                defaultMessage: props.actualData.image.altText,
                description: "",
              })
            }
          />
        ),
      }}
      idealState={{
        type: "component",
        label: props.idealData.label,
        component: (
          <Image
            width="100%"
            src={props.idealData.image.src.replace("{{locale}}", intl.locale)}
            alt={
              props.idealData.image.altText &&
              intl.formatMessage({
                id: props.idealData.image.altText,
                defaultMessage: props.idealData.image.altText,
                description: "",
              })
            }
          />
        ),
      }}
    />
  );
};
